import { Tabs, TabsContent, TabsList, TabsTrigger } from "@aix/ui"
import { BarChart, Mail, Send, Settings, Users } from "lucide-react"
import React, { useState } from "react"

import { AudienceManager } from "./components/AudienceManager"
import { CampaignBuilder } from "./components/CampaignBuilder"
import { CampaignList } from "./components/CampaignList"
import { ProviderSettings } from "./components/ProviderSettings"
import { QueueMonitor } from "./components/QueueMonitor"

export const EmailMarketingScreen: React.FC = () => {
  const [activeTab, setActiveTab] = useState("audiences")

  return (
    <div className="flex-1 overflow-hidden flex flex-col">
      <div className="flex-shrink-0 p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-primary">Email Marketing</h1>
            <p className="text-muted-foreground mt-1">Manage audiences and send bulk email campaigns</p>
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-6">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="h-full">
          <TabsList className="mb-4">
            <TabsTrigger value="audiences" className="flex items-center gap-2">
              <Users className="w-4 h-4" />
              Audiences
            </TabsTrigger>
            <TabsTrigger value="campaigns" className="flex items-center gap-2">
              <Mail className="w-4 h-4" />
              Campaigns
            </TabsTrigger>
            <TabsTrigger value="create" className="flex items-center gap-2">
              <Send className="w-4 h-4" />
              Create Campaign
            </TabsTrigger>
            <TabsTrigger value="queue" className="flex items-center gap-2">
              <BarChart className="w-4 h-4" />
              Queue Monitor
            </TabsTrigger>
            <TabsTrigger value="settings" className="flex items-center gap-2">
              <Settings className="w-4 h-4" />
              Settings
            </TabsTrigger>
          </TabsList>

          <TabsContent value="audiences" className="h-full">
            <AudienceManager />
          </TabsContent>

          <TabsContent value="campaigns" className="h-full">
            <CampaignList />
          </TabsContent>

          <TabsContent value="create" className="h-full">
            <CampaignBuilder />
          </TabsContent>

          <TabsContent value="queue" className="h-full">
            <QueueMonitor />
          </TabsContent>

          <TabsContent value="settings" className="h-full">
            <ProviderSettings />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  )
}
